<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">图文信息</li>
            </ol>
        </div>
        <div class="content-operator content-border">
            <el-button type="primary" size="small" @click="$common.goRouterLink({ name: 'imageTextDetail' })">添加</el-button>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query">
                <el-form-item label="分类：">
                    <el-select clearable v-model="query.type">
                        <el-option v-for="item in imageTextTypes" :key="item.name" :label="item.label" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitQuery(1)" size="small" icon="el-icon-search">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr />
        <div class="title">
            <span>图文列表</span>
        </div>
        <div class="content-data" v-if="imageTexts && 0 < imageTexts.length">
            <el-table :data="imageTexts" highlight-current-row border>
                <el-table-column label="序号" type="index" align="center"/>
                <el-table-column label="图标" align="center">
                    <template slot-scope="scope">
                        <el-image  :src="dynamicPath+scope.row.iconPath">
                            <div slot="error" class="image-slot">
                                <el-image title="加载失败"
                                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
                            </div>
                        </el-image>
                    </template>
                    <!--<template slot-scope="scope">
                        <img :src="dynamicPath+scope.row.iconPath" alt="加载失败..."/>
                    </template>-->
                </el-table-column>
                <el-table-column label="类型" align="center">
                    <template slot-scope="scope">
                        <span>{{imageTextTypeMap[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" round @click="$common.goRouterLink({ name: 'imageTextDetail', query: { imageTextId: scope.row.id } })">修改</el-button>
                        <el-button type="danger" size="mini" round @click="deleteImageText(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="imageText/pageImageText" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imageTexts: [],
            query: {},
            imageTextTypes: [],
            imageTextTypeMap: {},

            dynamicPath: config.dynamicResourcePath
        }
    },
    created() {
        var _this = this;
        var userInfo = _this.$common.cache('user_info');
        _this.imageTextTypes = _this.$common.enum_config('EImageTextType');
        _this.imageTextTypes.forEach((item)=>{
            _this.imageTextTypeMap[item.name] = item.label;
        });
    },
    methods: {
        
        fillData(_response) {
            var _this = this;
             _this.imageTexts=_response.items;
        },
        submitQuery(_num) {
            var _this = this;
            _this.imageTexts = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteImageText: function(_imageTextId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: 'imageText/deleteImageText',
                    data: {
                        imageTextId: _imageTextId
                    },
                    success: function(response) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.submitQuery();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        }
    }
}
</script>
<style scoped>
td {
    text-align: center;
}
</style>